// eslint-disable-next-line
import React from 'react';
import ListItem from '@mui/material/ListItem';
import { Typography, IconButton, ListItemText } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { COLOR_GRAY } from '../../constants/color-codes';
import * as PXBColors from '@brightlayer-ui/colors';
import { StatusLabel } from '../StatusLabel';

type Props = {
    id: string;
    title: string;
    subtitle: string;
    leadingIcon?: React.ReactNode;
    statusLabel?: string;
    statusBackgroundColor?: string;
    statusForegroundColor?: string;
    OnItemSelected?: Function;
};

export const CardListItem: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {
    // const classes = useStyles();
    const { OnItemSelected } = props;

    const OnSelected = (id: string, name: string): void => {
        if (OnItemSelected) OnItemSelected(id, name);
    };

    return (
        <div style={{ background: PXBColors.white[50], flex: '1 1 0px', overflow: 'auto', marginTop: 20, marginBottom: 20, borderRadius: 5, border: '1px solid rgba(222,224,227, 1)' }}>
            <ListItem
                id="list-item"
                style={{ display: 'flex', justifyContent: 'flex-end' }}
                onClick={(): void => OnSelected(props.id, props.title)}
                secondaryAction={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {props.statusLabel && (
                            <StatusLabel
                                status={props.statusLabel}
                                backgroundColor={props.statusBackgroundColor || PXBColors.green[500]}
                                foregroundColor={props.statusForegroundColor || PXBColors.white[50]}
                                isUpperCase
                            />
                        )}
                        <IconButton edge="end" id="list-item-next-icon" style={{ marginLeft: 'auto' }}>
                            <ChevronRight />
                        </IconButton>
                    </div>
                }
            >
                {props.leadingIcon && (
                    <div style={{ minWidth: 28, marginRight: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {props.leadingIcon}
                    </div>
                )}
                <ListItemText id="list-item-text">
                    <Typography
                        data-testid="list-item-title"
                        variant="subtitle1"
                    >
                        {props.title}
                    </Typography>

                    <Typography
                        data-testid="list-item-subtitle"
                        variant="body2"
                        sx={{
                            lineHeight: 1.25,
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            overflow: 'hidden',
                            wordWrap: 'break-word'
                        }}
                        style={{ marginTop: 3, color: COLOR_GRAY }}
                    >
                        {props.subtitle}
                    </Typography>
                </ListItemText>
            </ListItem>
        </div>
    );
};
